import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { routes } from './app.routes';
import { provideFirebase } from './firebase/firebase.providers';
import { FirebaseAuthService } from './services/auth/firebase-auth.service';
import { FirestoreService } from './services/database/firestore.service';
import { PatientDocumentService } from './services/database/patient-document.service';
import { InvoicingRequestService } from './services/database/invoicing-request.service';
import { FirebaseStorageService } from './services/storage/firebase-storage.service';
import { TypesensePatientService } from './services/search_utils/typesense-patient.service';
import { TypesenseMedicationService } from './services/search_utils/typesense-medication.service';
import { MedicationSearch, PatientSearch } from './services/search_utils/interconsulta-search';
import { UserProfileService } from './services/auth/user-profile.service';
import { MembershipService } from './services/auth/membership.service';
import { ThemeService } from './services/auth/theme.service';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(MatDialogModule, MatSnackBarModule),
    ...provideFirebase(),
    DatePipe,
    FirebaseAuthService,
    UserProfileService,
    MembershipService,
    ThemeService,
    FirestoreService,
    PatientDocumentService,
    FirebaseStorageService,
    InvoicingRequestService,
    TypesensePatientService,
    TypesenseMedicationService,
    PatientSearch,
    MedicationSearch,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
};
